module.exports = __webpack_public_path__ + "static/media/golf.e62b4960.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/screens/prizm/golf.jpg
// module id = 3564
// module chunks = 0